const STORAGE_KEY = 'ar_notification_sound_enabled';

let audioContext = null;
let soundReady = false;

export const isNotificationSoundEnabled = () => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(STORAGE_KEY) !== 'false';
};

export const setNotificationSoundEnabled = (enabled) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent('ar-notification-sound-change', { detail: { enabled } }));
};

const getAudioContext = () => {
  if (typeof window === 'undefined') return null;
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return null;
  if (!audioContext) audioContext = new AudioContextClass();
  return audioContext;
};

export const primeNotificationSound = async () => {
  if (!isNotificationSoundEnabled()) return false;
  const context = getAudioContext();
  if (!context) return false;
  try {
    if (context.state === 'suspended') await context.resume();
    soundReady = context.state === 'running';
    return soundReady;
  } catch (_) {
    return false;
  }
};

export const playNotificationSound = async () => {
  if (!isNotificationSoundEnabled()) return false;
  const context = getAudioContext();
  if (!context) return false;
  try {
    if (context.state === 'suspended') await context.resume();
    if (!soundReady && context.state !== 'running') return false;
    soundReady = true;

    const start = context.currentTime;
    const gain = context.createGain();
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(0.16, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.58);
    gain.connect(context.destination);

    [740, 988].forEach((frequency, index) => {
      const oscillator = context.createOscillator();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(frequency, start + (index * 0.16));
      oscillator.connect(gain);
      oscillator.start(start + (index * 0.16));
      oscillator.stop(start + 0.34 + (index * 0.16));
    });
    return true;
  } catch (_) {
    return false;
  }
};

